import { render, staticRenderFns } from "./ViewMyVisits.vue?vue&type=template&id=1bb59ade&"
import script from "./ViewMyVisits.vue?vue&type=script&lang=js&"
export * from "./ViewMyVisits.vue?vue&type=script&lang=js&"
import style0 from "./ViewMyVisits.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports